import React, { useState } from 'react'
import { getIdentityInitials, getIdentityName } from '../../../utils/identity'
import {
  Avatar,
  Box,
  IconButton,
  ListItem,
  TextField,
  Typography,
} from '@mui/material'
import { grey } from '@mui/material/colors'
import { Check, Close, Edit } from '@mui/icons-material'
import useIsAdmin from '../../../hooks/useIsAdmin'

const Note = ({
  avatarUrlsMap,
  identities,
  n,
  i,
  canEdit,
  updateNote,
  deleteNote,
}) => {
  const avatarUrl = avatarUrlsMap[n.authorId]
  const author = identities.find((i) => i.id === n.authorId)

  const authorName = getIdentityName(author)
  const [isEditing, setIsEditing] = useState(false)
  const [localCopy, setLocalCopy] = useState(JSON.parse(JSON.stringify(n)))
  const { isAdmin } = useIsAdmin()
  return (
    <ListItem
      sx={{
        backgroundColor: i % 2 === 0 ? grey[50] : null,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        p: 2,
      }}
    >
      <Box>
        <Typography sx={{ mb: 1 }}>
          <b>{authorName}</b> - <i>{new Date(n.createdOn).toLocaleString()}</i>
        </Typography>
        {!isEditing && (
          <Typography sx={{ pr: 2, whiteSpace: 'break-spaces' }}>
            {localCopy.noteContent}
          </Typography>
        )}
        {isEditing && (
          <TextField
            size='sm'
            margin='dense'
            label='Note'
            onChange={(e) =>
              setLocalCopy((prev) => ({ ...prev, noteContent: e.target.value }))
            }
            value={localCopy.noteContent}
            multiline
            rows={3}
            fullWidth
          />
        )}
      </Box>
      <Box sx={{ display: 'flex' }}>
        {canEdit && !isEditing && (
          <>
            <IconButton onClick={() => setIsEditing(true)}>
              <Edit />
            </IconButton>
            {isAdmin && (
              <IconButton onClick={() => deleteNote()}>
                <Close />
              </IconButton>
            )}
          </>
        )}
        {isEditing && (
          <Button
            color='primary'
            onClick={() => {
              updateNote(localCopy)
              setIsEditing(false)
            }}
          >
            Save Note
          </Button>
        )}
        {(avatarUrl || author) && (
          <Avatar sx={{ ml: 2 }} src={avatarUrl} alt={authorName}>
            {author ? getIdentityInitials(author) : null}
          </Avatar>
        )}
      </Box>
    </ListItem>
  )
}

export default Note
